export default __webpack_public_path__ + "static/1-4177a957e4e22f0f3be612085d4892e5.jpg";